export const IMG = {
  hero: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  portraitMan:
    "https://images.unsplash.com/photo-1565884280295-98eb83e41c65?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  podcastMan:
    "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  studioHost:
    "https://images.unsplash.com/photo-1694881227511-ca3b9f69ea91?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  readingWoman:
    "https://images.unsplash.com/photo-1589156298569-b33c58057afc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  studyMan:
    "https://images.unsplash.com/photo-1581091595283-04de15a05a01?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
};

export const STAGES = [
  { step: 1, name: "ENTER", verb: "Cross the threshold of stillness." },
  { step: 2, name: "REMEMBER", verb: "Recall the spark within the heart." },
  { step: 3, name: "EXPLORE", verb: "Examine wisdom with a sacred question." },
  { step: 4, name: "DISCERN", verb: "Separate ego noise from soulful truth." },
  { step: 5, name: "INTEGRATE", verb: "Weave realization into daily life." },
  { step: 6, name: "EMBODY", verb: "Live compassion as physical presence." },
  { step: 7, name: "SYNTHESIZE", verb: "Unify heart with community." },
  { step: 8, name: "RETURN", verb: "Rest in the unconditioned Divine." },
];

export const PATHWAYS = [
  {
    slug: "listen",
    label: "Listen",
    verse: "Podcast, Radio & Music",
    body: "Sit with teachings, tune the heart, and let sound become sanctuary.",
  },
  {
    slug: "learn",
    label: "Learn",
    verse: "The Learning Circle",
    body: "Courses and Encounters for the interior life — walk them at your pace.",
  },
  {
    slug: "read",
    label: "Read",
    verse: "The Living Library",
    body: "Books, reflections and articles that unlock the inner chamber.",
  },
  {
    slug: "gather",
    label: "Gather",
    verse: "Sacred Assembly",
    body: "Circles, retreats and virtual gatherings — presence with others.",
  },
  {
    slug: "join",
    label: "Join",
    verse: "Enter Communion",
    body: "Belong to the Temple — from the Open Temple to the Learning Circle.",
  },
];

export const PODCASTS = [
  {
    id: "pod-1",
    kind: "podcast",
    title: "The Kingdom Within the Chest",
    host: "Rev. Malik Osei",
    episode: "Episode 42",
    duration: "38:12",
    releasedAt: "Feb 6, 2026",
    art: "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    summary:
      "On the doctrine of interior discovery — how the Divine has never left the heart's inner chamber.",
  },
  {
    id: "pod-2",
    kind: "podcast",
    title: "Re-Membering: Reassembling the Soul",
    host: "Sister Ayo Bright",
    episode: "Episode 41",
    duration: "44:03",
    releasedAt: "Jan 30, 2026",
    art: "https://images.unsplash.com/photo-1694881227511-ca3b9f69ea91?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    summary:
      "Awakening as an act of memory — not learning something new, but recovering what was always ours.",
  },
  {
    id: "pod-3",
    kind: "podcast",
    title: "Compassion as a Practice, Not a Feeling",
    host: "Rev. Malik Osei",
    episode: "Episode 40",
    duration: "31:47",
    releasedAt: "Jan 23, 2026",
    art: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    summary:
      "Compassion is a muscle. In this episode we practice the small ordinary gestures that grow it.",
  },
  {
    id: "pod-4",
    kind: "podcast",
    title: "The Return: When Home is Not a Place",
    host: "Brother Kojo Wynter",
    episode: "Episode 39",
    duration: "29:18",
    releasedAt: "Jan 16, 2026",
    art: "https://images.unsplash.com/photo-1565884280295-98eb83e41c65?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    summary:
      "A meditation on returning to the unconditioned presence beneath our restless days.",
  },
];

export const MUSIC = [
  {
    id: "mus-1",
    kind: "music",
    title: "Interior Chamber (Ambient)",
    host: "Temple Ensemble",
    duration: "12:04",
    art: "https://images.unsplash.com/photo-1589156298569-b33c58057afc?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "mus-2",
    kind: "music",
    title: "Vespers for a Quiet Heart",
    host: "The Choir of the Human Heart",
    duration: "18:41",
    art: "https://images.unsplash.com/photo-1581091595283-04de15a05a01?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "mus-3",
    kind: "music",
    title: "Threshold Drone",
    host: "N. Adekunle",
    duration: "22:00",
    art: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
];

export const RADIO_SCHEDULE = [
  { time: "05:00", show: "Dawn Vespers", host: "Sister Ayo" },
  { time: "08:00", show: "Morning Teachings", host: "Rev. Malik" },
  { time: "12:00", show: "The Contemplative Hour", host: "Br. Kojo" },
  { time: "17:00", show: "Community Voices", host: "Guest Circle" },
  { time: "21:00", show: "Night Song", host: "Temple Ensemble" },
];

export const COURSES = [
  {
    id: "c1",
    title: "The Doctrine of Love",
    stage: 1,
    lessons: 6,
    progress: 100,
    duration: "3 weeks",
    teacher: "Rev. Malik Osei",
    tagline: "Enter the practice by opening the door of the heart.",
    art: "https://images.unsplash.com/photo-1589156298569-b33c58057afc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "What Love Is Not",
      "The Door of the Heart",
      "Stillness as Welcome",
      "The First Breath",
      "Beholding Another",
      "Closing Blessing",
    ],
  },
  {
    id: "c2",
    title: "Re-Membering the Body",
    stage: 2,
    lessons: 8,
    progress: 62,
    duration: "4 weeks",
    teacher: "Sister Ayo Bright",
    tagline: "Recover the sacred somatic memory the world tried to make you forget.",
    art: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "The Body as Temple",
      "Ancestral Breath",
      "Listening Bones",
      "Grief that Remembers",
      "Joy that Remembers",
      "Song of the Belly",
      "Feet on Ground",
      "Return",
    ],
  },
  {
    id: "c3",
    title: "Contemplative Inquiry",
    stage: 3,
    lessons: 10,
    progress: 28,
    duration: "6 weeks",
    teacher: "Br. Kojo Wynter",
    tagline: "Ask the question that only silence can answer.",
    art: "https://images.unsplash.com/photo-1581091595283-04de15a05a01?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "The Sacred Question",
      "Sitting With What Arises",
      "Mysteries vs. Problems",
      "The Cloud of Unknowing",
      "The Interior Witness",
      "When Answers Dissolve",
      "The Fertile Void",
      "Inquiry as Prayer",
      "The Living Word",
      "Rest",
    ],
  },
  {
    id: "c4",
    title: "Discernment of Spirits",
    stage: 4,
    lessons: 7,
    progress: 0,
    duration: "5 weeks",
    teacher: "Rev. Malik Osei",
    tagline: "Learn to tell the ego's whisper from the soul's quiet voice.",
    art: "https://images.unsplash.com/photo-1565884280295-98eb83e41c65?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "Two Voices",
      "The Ego's Signature",
      "The Soul's Signature",
      "Fear vs. Reverence",
      "Consolation & Desolation",
      "The Discerning Community",
      "Living the Choice",
    ],
  },
  {
    id: "c5",
    title: "Embodied Compassion",
    stage: 6,
    lessons: 9,
    progress: 0,
    duration: "6 weeks",
    teacher: "Sister Ayo Bright",
    tagline: "Compassion trained as physical practice, not sentiment.",
    art: "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "The Hand That Reaches",
      "The Ear That Listens",
      "The Table That Feeds",
      "Boundaries as Care",
      "Anger as Compassion",
      "Compassion for Enemies",
      "Compassion for Self",
      "The Work of Justice",
      "The Ordinary Saint",
    ],
  },
  {
    id: "c6",
    title: "The Return: Resting in Presence",
    stage: 8,
    lessons: 5,
    progress: 0,
    duration: "8 weeks",
    teacher: "Rev. Malik Osei",
    tagline: "When the practice becomes the practitioner.",
    art: "https://images.unsplash.com/photo-1694881227511-ca3b9f69ea91?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    lessonList: [
      "There is Nowhere to Go",
      "The Face Before Birth",
      "Silence That Sings",
      "The Ordinary Miracle",
      "Rest",
    ],
  },
];

export const LIBRARY = [
  {
    id: "lib-1",
    type: "Book",
    title: "The Interior Chamber",
    author: "Rev. Malik Osei",
    length: "212 pages",
    art: "https://images.unsplash.com/photo-1589156298569-b33c58057afc?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "The chamber was never elsewhere. It has always been the shape of your own breathing.",
  },
  {
    id: "lib-2",
    type: "Article",
    title: "On Re-Membering",
    author: "Sister Ayo Bright",
    length: "9 min read",
    art: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "Awakening is not addition. It is subtraction — the removal of everything that agreed to forget.",
  },
  {
    id: "lib-3",
    type: "Reflection",
    title: "A Small Practice for Mornings",
    author: "Br. Kojo Wynter",
    length: "3 min read",
    art: "https://images.unsplash.com/photo-1581091595283-04de15a05a01?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "Before the phone, before the news — set one palm on your chest and simply say, 'You are here.'",
  },
  {
    id: "lib-4",
    type: "Book",
    title: "Compassion as Craft",
    author: "The Temple Council",
    length: "168 pages",
    art: "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "The compassionate act is not spontaneous — it is trained. Kindness is a discipline that becomes a presence.",
  },
  {
    id: "lib-5",
    type: "Article",
    title: "Kingdom Within, Kingdom Between",
    author: "Rev. Malik Osei",
    length: "12 min read",
    art: "https://images.unsplash.com/photo-1565884280295-98eb83e41c65?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "What is discovered inside becomes visible between us — or it has not been discovered at all.",
  },
  {
    id: "lib-6",
    type: "Reflection",
    title: "The Blessing of Small Returns",
    author: "Sister Ayo Bright",
    length: "5 min read",
    art: "https://images.unsplash.com/photo-1694881227511-ca3b9f69ea91?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    excerpt:
      "You do not fail the path when your mind wanders. You walk the path each time you return.",
  },
];

export const EVENTS = [
  {
    id: "e1",
    title: "New Moon Circle: Silence & Song",
    date: "Feb 27, 2026",
    time: "7:00 PM EST",
    format: "Virtual",
    seats: "48 open",
    location: "Zoom Sanctuary",
    art: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    description:
      "A monthly threshold gathering — 30 minutes of shared silence, followed by community song.",
  },
  {
    id: "e2",
    title: "Weekend Retreat: The Interior Chamber",
    date: "Mar 14–16, 2026",
    time: "All day",
    format: "In-person",
    seats: "12 open",
    location: "Ashe Retreat Center, GA",
    art: "https://images.unsplash.com/photo-1589156298569-b33c58057afc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    description:
      "Three days of guided contemplative practice with Rev. Malik Osei. Meals and lodging included.",
  },
  {
    id: "e3",
    title: "Community Gathering: Compassion in Action",
    date: "Apr 5, 2026",
    time: "10:00 AM",
    format: "Hybrid",
    seats: "Open",
    location: "Atlanta + Livestream",
    art: "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    description:
      "A community day of service, teaching and shared meal. All are welcome.",
  },
  {
    id: "e4",
    title: "Equinox Vigil",
    date: "Mar 20, 2026",
    time: "8:00 PM",
    format: "Virtual",
    seats: "Open",
    location: "Temple Radio Live",
    art: "https://images.unsplash.com/photo-1694881227511-ca3b9f69ea91?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    description:
      "A 2-hour vigil marking the turning of the season with music, teaching and shared prayer.",
  },
];

export const TIERS = [
  {
    name: "Seeker",
    cost: "Free",
    tag: "Begin here",
    features: [
      "Full public library access",
      "Weekly newsletter — 'From the Chamber'",
      "Free podcast & radio",
      "Introductory course: The Doctrine of Love",
    ],
  },
  {
    name: "Pilgrim",
    cost: "$18 / month",
    tag: "Walk the path",
    highlight: true,
    features: [
      "Everything in Seeker",
      "Full Learning Circle (all 8 stages)",
      "Members-only reflections & books",
      "Monthly New Moon Circle",
      "Save & bookmark across the platform",
    ],
  },
  {
    name: "Guardian",
    cost: "$48 / month",
    tag: "Steward the Temple",
    features: [
      "Everything in Pilgrim",
      "Priority retreat registration",
      "Small-group direction sessions",
      "Guardian's contemplative journal",
      "Support the free access of others",
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The Temple met me at a threshold I had been standing at for years. It felt like being welcomed home by someone who already knew my name.",
    name: "Kendra M.",
    role: "Pilgrim member since 2024",
  },
  {
    quote:
      "This is not a church. It is a way of listening. And it has changed the shape of my days.",
    name: "Devon R.",
    role: "Seeker",
  },
  {
    quote:
      "The 8-stage path gave me a language for what I've always been living. I finally have companions.",
    name: "Amara J.",
    role: "Guardian member",
  },
];

export const REFLECTION_OF_THE_DAY = {
  id: "reflection-daily",
  kind: "reflection",
  title: "Reflection of the Day — 'You Have Always Been Here'",
  host: "Rev. Malik Osei",
  duration: "6:12",
  art: "https://images.unsplash.com/photo-1565884280295-98eb83e41c65?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  body:
    "Before the day requires anything of you — before the phone, the news, the list — place one palm on your chest. Feel that it is warm. That warmth was never earned. It has been waiting.",
};

export const RADIO_LIVE = {
  id: "radio-live",
  kind: "radio",
  title: "Temple Radio — Live",
  host: "The Contemplative Hour with Br. Kojo",
  duration: "LIVE",
  art: "https://images.unsplash.com/photo-1594434533760-02e0f3faaa68?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
};
